import { Alert, Link } from "@mui/material";
import { RenewalStatus } from "../Case.types";
import { BulkRenewalAction } from "./bulkRenewal.functions";

export type BulkRenewalBannerProps = {
    bulkAction: BulkRenewalAction;
    selectedCount: number;
    onDeselectAll: () => void;
};

function BulkRenewalBanner(props: BulkRenewalBannerProps) {
    const instruction =
        props.bulkAction === RenewalStatus.Renew ? "Bulk renew: Select the cases you want to renew." : "Bulk expire: Select the cases you want to let expire.";

    return (
        <Alert severity={"info"} sx={{ mb: 3, backgroundColor: "secondary.light", color: "primary.main", "& .MuiAlert-icon": { color: "primary.main" } }}>
            {instruction} {props.selectedCount} selected.{" "}
            {props.selectedCount > 0 && (
                <Link component={"button"} variant={"body2"} onClick={props.onDeselectAll} sx={{ verticalAlign: "baseline" }}>
                    Deselect all.
                </Link>
            )}
        </Alert>
    );
}

export default BulkRenewalBanner;
